import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  Grid,
  Avatar,
  List,
  ListItem,
  ListItemIcon,
  ListItemAvatar,
  ListItemText,
  Checkbox,
  Typography,
} from '@material-ui/core'
import { getProductPriceForDay } from '../../../utils/priceUtils';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto',
    maxHeight: '75vh'
  },
  originalPrice: {
    textDecoration: 'line-through',
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(1),
  },
  finalPrice: {
    fontWeight: 'bold',
  }
}))


export default function DefaultList({ checkList, items = [], setSelected = () => { }, createSecondary = () => { } }) {
  const classes = useStyles()
  const [selectedItem, setSelectedItem] = React.useState('')

  const handleListItemClick = (event, item) => {
    setSelectedItem(item.id);
    setSelected(item)
  }


  return (
    <List dense className={classes.root}>
      {
        items.map(item => {
          const priceInfo = getProductPriceForDay(item);
          let description = item.sale ? `${item.name} (EN OFERTA)` : item.name
          if (item.interfaceCode) {
            description = `${item.interfaceCode} - ${description}`
          }
          return (
            <ListItem key={item.id} button selected={selectedItem === item.id} onClick={(event) => handleListItemClick(event, item)}>
              {
                checkList &&
                <ListItemIcon>
                  <Checkbox
                    checked={item?.checked || false}
                    tabIndex={-1}
                    disableRipple
                    color="primary"
                  />
                </ListItemIcon>
              }

              <ListItemAvatar>
                <Avatar
                  alt={description}
                  src={item.src ? item.src : item.img}
                />
              </ListItemAvatar>
              <Grid item xs={9}>
                <ListItemText id={item.id} primary={description} secondary={createSecondary(item)} />
              </Grid>
              <Grid item container xs={3} justify="flex-end" alignItems="flex-start"  >
                <Grid item xs={12} style={{ textAlign: 'right' }}>
                  <Typography variant='body2' component="div">
                    {priceInfo.originalPrice && (
                      <span className={classes.originalPrice}>
                        ${priceInfo.originalPrice}
                      </span>
                    )}
                    <span className={classes.finalPrice}>
                      ${priceInfo.finalPrice}
                    </span>
                  </Typography>
                  {priceInfo.extraDiscount && (
                    <Typography variant="caption" color="textSecondary">
                      -${priceInfo.extraDiscount} retirando en el local
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='p' color={item.stock ? 'textPrimary' : 'error'} >{`Stock: ${Number(item.stock || 0)}`}</Typography>
                </Grid>
              </Grid>

              {/* <ListItemSecondaryAction>
                                <Checkbox
                                    edge="end"
                                    onChange={handleToggle(item.id)}
                                    checked={checked.indexOf(item.id) !== -1}
                                    inputProps={{ 'aria-labelledby': item.id }}
                                />
                            </ListItemSecondaryAction> */}
            </ListItem>
          )
        })
      }
    </List>
  )
}
